import React from 'react'
import { useReactiveVar } from '@apollo/client'
import MapLayer from '../../components/MapLayer'
import NavBar from '../../components/NavBar'
import OrderPanel from '../../components/OrderPanel'
import RouteBuilder from '../../components/RouteBuilder'
import MapProvider from '../../components/providers/MapProvider'
import ProfileProvider from '../../components/providers/ProfileProvider'
import { OrderStatus } from '../../components/OrderStatus/OrderStatus'
import { AuthContext } from '../../context/AuthContext'
import { useGetOrdersQuery } from '../../components/OrdersHistory/__generated__/getOrders'
import { activeOrderIdVar } from '../../store/cache'

export function MainPage() {
    const activeOrderId = useReactiveVar(activeOrderIdVar)
    const { state } = React.useContext(AuthContext)
    const token = state?.userToken

    // Восстанавливаем активный заказ после перезагрузки страницы.
    const { data: activeData } = useGetOrdersQuery({
        skip: !token || !!activeOrderId,
        variables: { statuses: [2, 5, 7, 8], limit: 1, offset: 0 }
    })

    React.useEffect(() => {
        const id = activeData?.orders?.items?.[0]?.id
        if (id && !activeOrderId) {
            activeOrderIdVar(id)
        }
    }, [activeData, activeOrderId])

    return (
        <>
            <ProfileProvider>
                <>
                    <NavBar />
                    {activeOrderId ? (
                        <MapProvider>
                            <OrderStatus
                                orderId={activeOrderId}
                                onDone={() => activeOrderIdVar(null)}
                            />
                        </MapProvider>
                    ) : (
                        <MapProvider>
                            <>
                                <RouteBuilder />
                                <MapLayer />
                                <div className='div-transition' />
                                <OrderPanel />
                            </>
                        </MapProvider>
                    )}
                </>
            </ProfileProvider>
        </>
    )
}
